const technologyCategories = [
  'Технологии',
  'Браузеры',
  'Устройства',
  'Веб-сервисы',
  'iOS',
  'macOS',
  'Windows',
];

const healthCategories = ['Здоровье', 'Спорт и фитнес'];

const hasTag = (tags: Tag[], title: string) => tags.some((tag) => tag.title === title);

export const getEditorialForAnalytics = (article?: ISingleArticle) => {
  if (!article) {
    return '';
  }

  const { type, categories, tags } = article;

  // Всегда здоровье для статей с type health
  if (type === 'health') {
    return 'Здоровье';
  }

  // Для жизни используется тэг вместо категории, проверяем отдельно.
  if (hasTag(tags, 'Редакция «Жизнь»')) {
    return 'Жизнь';
  }

  let editorial = '';

  // Обходим весь массив вместо find\includes, чтобы проверить что в массиве нет "новости", за один
  // проход
  for (const { title } of categories) {
    // Новости имеют приоритет над всеми другими редакциями, сразу возвращаем
    if (title === 'Новости') {
      return 'Новости';
    }

    if (technologyCategories.includes(title)) {
      editorial = 'Технологии';
    }

    // Если категории здоровья то так же не должно быть подкастов.
    if (healthCategories.includes(title)) {
      editorial = categories.some((category) => category.title === 'Подкасты') ? '' : 'Здоровье';
    }

    if (title === 'Покупки') {
      editorial = 'Покупки';
    }

    if (title === 'Кино') {
      editorial = 'Кино';
    }

    if (title === 'Еда') {
      editorial = 'Еда';
    }
  }

  return editorial;
};
